<template>
  <div>
    <!--  <v-btn
      v-for="(item, i) in items.slice(0, large ? items.length : 3)"
      :key="i"
      fab
      class="ma-2"
      :large="large"
      color="info"
    > -->
    <v-btn
      v-for="(item, i) in items"
      :key="i"
      fab
      class="ma-2"
      color="primary"
      small
    >
      <v-icon v-text="item.icon" />
    </v-btn>
  </div>

</template>

<script>
export default {
  props: {
    isTransparent: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    items: [
      {
        name: 'Instagram',
        icon: 'mdi-instagram'
      },
      {
        name: 'YouTube',
        icon: 'mdi-youtube'
      },
      {
        name: 'LinkedIn',
        icon: 'mdi-linkedin'
      },
      {
        name: 'Facebook',
        icon: 'mdi-facebook'
      },
      {
        name: 'Yelp',
        icon: 'mdi-yelp'
      },
      {
        name: 'Twitter',
        icon: 'mdi-twitter'
      }
    ]
  })
}
</script>
